import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Company } from '@/models/Company'

export default new CachedResourceStore<Company>(Company, {
	namespaced: true
})
